import React, { useState, useEffect, useContext } from "react";
import {
    Grid,
    TextField,
} from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import { ActionContext } from 'src/contexts/ActionContext';
import { BusinessManagerContext } from "src/contexts/BusinessManagerContext";

function OtherWishes(props) {
    const errorBorderStyle = {
        "& .MuiInputBase-root.Mui-disabled": {
            "& fieldset": {
                borderColor: "#FF1943"
            }
        }
    }
    const { t } = useTranslation();
    const { eepBMData, setEepBMDataContext } = useContext(BusinessManagerContext);
    const { actionToggle } = useContext(ActionContext);
    const isVisu = !actionToggle;
    const [data, setData] = useState({
        mobility: '',
        functionalMobility: '',
        otherWill: '',
    });
    useEffect(() => {
        setData({
            mobility: props.data.mobility,
            functionalMobility: props.data.functionalMobility,
            otherWill: props.data.otherWill,
        })
    }, [props.data]);
    const handleChange = (e) => {
        const { name, value } = e.target;
        setData({
            ...data,
            [name]: value
        });
    }
    const setDataContextValue = () => {
        eepBMData.mobility = data.mobility;
        eepBMData.functionalMobility = data.functionalMobility;
        eepBMData.otherWill = data.otherWill;
    }
    return (
        <>

            <Grid item xs={12}>
                <h3 style={{ fontStyle: 'italic', fontWeight: 'normal', marginLeft: 2, marginRight: 2 }}>
                    <Trans>eepBm.otherWishes.label</Trans>
                </h3>
            </Grid>
            <div style={{ backgroundColor: '#ffffff', marginTop: -10 }} >
                <Grid container direction="row" alignItems="stretch" sx={{ padding: 1 }} spacing={1}>
                    <Grid item xs={12} >
                        <TextField
                            label={t('eepBm.otherWishes.field1')}
                            variant="outlined"
                            fullWidth
                            name="mobility"
                            value={data.mobility}
                            onChange={handleChange}
                            onBlur={setDataContextValue}
                            multiline
                            inputProps={{
                                maxLength: 4094
                            }}
                            required
                            error={data.mobility == "" || data.mobility == null}
                            sx={(data.mobility == "" || data.mobility == null) ? errorBorderStyle : {}}
                            disabled={isVisu}
                        />
                    </Grid>
                </Grid>
                <Grid container direction="row" alignItems="stretch" sx={{ padding: 1 }} spacing={1}>
                    <Grid item xs={12} >
                        <TextField
                            label={t('eepBm.otherWishes.field2')}
                            variant="outlined"
                            fullWidth
                            name="functionalMobility"
                            value={data.functionalMobility}
                            onChange={handleChange}
                            onBlur={setDataContextValue}
                            multiline
                            inputProps={{
                                maxLength: 4094
                            }}
                            disabled={isVisu}
                        />
                    </Grid>
                </Grid>
                <Grid container direction="row" alignItems="stretch" sx={{ padding: 1 }} spacing={1}>
                    <Grid item xs={12} >
                        <TextField
                            label={t('eepBm.otherWishes.field3')}
                            variant="outlined"
                            fullWidth
                            name="otherWill"
                            value={data.otherWill}
                            onChange={handleChange}
                            onBlur={setDataContextValue}
                            multiline
                            inputProps={{
                                maxLength: 4094
                            }}
                            disabled={isVisu}
                        />
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default OtherWishes;